import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import validationSchema from './SiteCreator.schema';
import { FormInputField, FormSelectField } from '../../common/components/formFields';
import { constantToSelect } from '../../common/helpers';
import { SiteStatusName } from '../../constants/SiteCreator';
import ComponentCard from '../../common/components/cards/ComponentCard';

const initialValues = {
  title: '',
  status: '',
};

const siteCreatorStatuses = constantToSelect(SiteStatusName);

function SiteCreatorSearch({ onSearch }) {
  return (
    <Col md="12">
      <ComponentCard title="Search Site" isCollapsible>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSearch}
          validateOnBlur
        >
          {() => (
            <Form noValidate>
              <Row>
                <Col md="4">
                  <FormInputField name="title" label="Name" />
                </Col>
                <Col md="4">
                  <FormSelectField
                    name="status"
                    label="Status"
                    options={siteCreatorStatuses}
                  />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Button className="mt-4 float-end rounded-pill btn-primary" type="submit">
                    Search
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ComponentCard>
    </Col>
  );
}

export default SiteCreatorSearch;
